import { Outlet } from 'react-router';

import { EulaGate } from '@/legal';

/**
 * Layout of the post-activation welcome screens (ESCLOUD-333). It exists for one
 * reason: the EULA overlay is mounted by layouts, and an invited member reaches
 * `/welcome/profile` without ever having accepted the licence; the buyer
 * accepted it on the payment page and never sees the dialog.
 *
 * Hook-free on purpose: `router.spec.tsx` calls layouts as plain functions to
 * read what they mount.
 */
export function WelcomeLayout() {
    return (
        <>
            <EulaGate />
            <Outlet />
        </>
    );
}
